export default "__VITE_ASSET__8a109d27__"